import { isValidPhoneNumber as isValidPhoneNumberLib, parsePhoneNumberWithError } from 'libphonenumber-js';

export const e164Format = (phone) => {
    try {
        const phoneInstance = parsePhoneNumberWithError(phone, 'US');
        return phoneInstance.format('E.164');
    } catch (e) {
        return null;
    }
};

export const isValidPhoneNumber = (phone) => {
    try {
        return isValidPhoneNumberLib(phone, 'US');
    } catch (e) {
        console.error(e);
        return false;
    }
};
